// Components
import { Link } from '@tracklib/kit'

// Utils
import { KEYS_CHOICES } from '@constants'

type KeyProps = {
  tonal: string
}

const Key = ({ tonal }: KeyProps): JSX.Element => {
  const keyObj = tonal && KEYS_CHOICES.find(x => x.id === tonal)
  const keyQuery = keyObj && keyObj.name ? { keys: keyObj.id } : null
  return (
    <Link to="/tracks" query={keyQuery}>
      {keyObj && keyObj.name}
    </Link>
  )
}

export default Key
